import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { CheckCircle } from "react-feather";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import SubscriptionManagement from "../Subscription";
import PricingCalculatorModel from "../myprojects/createProjectSteps/PricingCalculatorModel";
import StripeElement from "../../../common/stripeComponent/StripeElement";
import OrderButton from "../../components/orderButton/OrderButton";
import CreateProjectInfoModel from "../myprojects/myProjectsModels/CreateProjectInfoModel";
import WPCalculator from "../../WPCalc/WPCalculator";
import { getCurrentUser } from "../../../redux/currentUserSlice/currentUser.thunk";
import { useDispatch } from "react-redux";

const Pricing = () => {
  const dispatch = useDispatch();
  const [pricingCalculator, setPricingCalculator] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  const [projectInfoModel, setProjectInfoModel] = useState(false);

  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);

  return (
    <div className="plans-offer">
      <div className="row justify-content-between align-items-center mb-2">
        <div className="d-flex back-div col-lg-9 col-12">
          {/* <Breadcrumbs
            title="User Profile"
            data={[{ title: "User Profile", link: "" }]}
          /> */}
        </div>
        <div className="col-12 col-md-4 col-lg-3 text-start text-lg-end">
          <OrderButton
            setProjectInfoModel={setProjectInfoModel}
            projectInfoModel={projectInfoModel}
          />
        </div>
      </div>
      <>
        <h1 className="text-center my-2 mb-3 section-title">
          Pay As You Go Pricing
        </h1>
      </>
      <Container>
        <Row className="pricing-card">
          <Col xs={12} md={12} lg={12} xl={12} className="m-auto">
            <Row>
              <Col xs={12} md={6} lg={6} xl={4}>
                <Card
                  className={classNames("bordered shadow-none ala-carte", {})}
                >
                  <CardHeader className="d-flex flex-column align-items-center">
                    <h2>Instagram Video</h2>
                  </CardHeader>

                  <CardBody className="p-0 d-flex flex-column align-items-center justify-content-evenly w-100">
                    <div className="d-flex flex-column align-items-center">
                      <h4>1 Minute video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$249</span>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} className="mt-3 mt-md-0">
                <Card
                  className={classNames("bordered shadow-none ala-carte ", {})}
                >
                  <CardHeader className="d-flex flex-column align-items-center">
                    <h2>Music Highlight Video </h2>
                  </CardHeader>

                  <CardBody className="p-0 d-flex flex-column align-items-center justify-content-evenly">
                    <div className="d-flex flex-column align-items-center">
                      <h4>2 - 3 Minutes Video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$399</span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <h4>4 - 6 Minutes Video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$499</span>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} className="mt-3 mt-xl-0">
                {/* key={row.id} */}
                <Card
                  className={classNames("bordered shadow-none ala-carte", {})}
                >
                  <CardHeader className="d-flex flex-column align-items-center">
                    <h2>Narrative Highlight Video </h2>
                  </CardHeader>
                  {/* <div className="d-flex flex-column align-items-center justify-content-evenly"> */}
                  <CardBody className="p-0 d-flex flex-column align-items-center justify-content-evenly">
                    <div className="d-flex flex-column align-items-center">
                      <h4>3 - 5 Minutes Video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$599</span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <h4>6 - 8 Minutes Video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$669</span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <h4>9 - 12 Minutes Video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$739</span>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  {/* </div> */}
                </Card>
              </Col>
              {/* </Row>
            <Row className="mt-3"> */}
              <Col xs={12} md={6} lg={6} xl={4} className="mt-3">
                <Card
                  className={classNames("bordered shadow-none ala-carte ", {})}
                >
                  <CardHeader className="d-flex flex-column align-items-center">
                    <h2>Cinematic Feature Film</h2>
                  </CardHeader>

                  <CardBody className="p-0 d-flex flex-column align-items-center justify-content-evenly">
                    <div className="d-flex flex-column align-items-center">
                      <h4>13 - 15 Minutes video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$799</span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <h4>16 - 20 Minutes video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$879</span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <h4>21 - 25 Minutes video</h4>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">$989</span>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={12} xl={8} className="mt-3">
                {/* key={row.id} */}
                <Card
                  className={classNames("bordered shadow-none ala-carte", {})}
                >
                  <CardHeader className="d-flex ps-2 pe-2 flex-column align-items-center">
                    <h2> Documentary Edits</h2>
                  </CardHeader>

                  <CardBody className="p-0 d-flex flex-column align-items-center justify-content-evenly">
                    <div className="row">
                      <div className="d-flex flex-column col-sm-6 col-12 align-items-center justify-content-center">
                        <h4>Ceremony Edit</h4>
                        <div className="annual-plan">
                          <div className="price-div">
                            <span className="price">$99</span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column col-sm-6 col-12 align-items-center justify-content-center">
                        <h4>Dances Only</h4>
                        <div className="annual-plan">
                          <div className="price-div">
                            <span className="price">$75</span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column col-sm-6 col-12 align-items-center justify-content-center">
                        <h4>Reception Edit</h4>
                        <div className="annual-plan">
                          <div className="price-div">
                            <span className="price">$99</span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column col-sm-6 col-12 align-items-center justify-content-center">
                        <h4>Speeches Only</h4>
                        <div className="annual-plan">
                          <div className="price-div">
                            <span className="price">$75</span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column col-12 align-items-center justify-content-center">
                        <h4 className="ps-2 pe-2">Ceremony + Reception Edit</h4>
                        <div className="annual-plan">
                          <div className="price-div">
                            <span className="price">$149</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row
          className="mt-2 mx-0"
          style={
            {
              // background:
              //   "linear-gradient(2.32deg, #4da692 -241.36%, #0a1d37 113.05%)",
              // borderRadius: "2.29rem",
            }
          }
        >
          <h1
            className="text-center mb-1 mt-2 section-title  fw-bolder "
            style={{ color: "#f8a78c " }}
          >
            Join Carat Club Annual Membership and Save Big
          </h1>
          <h3 className="text-center mb-2">
            <a href="https://www.uncutgems.com/pricing/" target="_blank">
              What is Carat Club?
            </a>
          </h3>
        </Row>
      </Container>
      <hr />
      <div className="text-center d-flex flex-column flex-md-row justify-content-center">
        <Button.Ripple
          className="ornge-btn"
          color="flat-primary"
          onClick={(e) => {
            e.preventDefault();
            setModalOpen(true);
          }}
        >
          {/* Want a Package Suitable For Your Needs? */}
          Compare With Pay As You Go Pricing
        </Button.Ripple>
        <Button.Ripple
          className="ornge-btn ms-0 ms-md-1 mt-1 mt-md-0"
          color="flat-primary"
          onClick={(e) => {
            e.preventDefault();
            setPricingCalculator(true);
          }}
        >
          {/* Want a Package Suitable For Your Needs? */}
          Calculate the Right Package for You!
        </Button.Ripple>
      </div>
      <hr />
      <StripeElement>
        <PricingCalculatorModel
          setShow={setPricingCalculator}
          show={pricingCalculator}
        />
      </StripeElement>

      <SubscriptionManagement title />
      <hr />
      <div className="text-center d-flex flex-column flex-md-row justify-content-center">
        <Button.Ripple
          className="ornge-btn"
          color="flat-primary"
          onClick={(e) => {
            e.preventDefault();
            setModalOpen(true);
          }}
        >
          {/* Want a Package Suitable For Your Needs? */}
          Compare With Pay As You Go Pricing
        </Button.Ripple>
        <Button.Ripple
          className="ornge-btn ms-0 ms-md-1 mt-1 mt-md-0"
          color="flat-primary"
          onClick={(e) => {
            e.preventDefault();
            setPricingCalculator(true);
          }}
        >
          {/* Want a Package Suitable For Your Needs? */}
          Calculate the Right Package for You!
        </Button.Ripple>
      </div>
      <hr />

      {projectInfoModel && (
        <CreateProjectInfoModel
          show={projectInfoModel}
          setShow={setProjectInfoModel}
        />
      )}
      {modalOpen && (
        <WPCalculator modalOpen={modalOpen} setModalOpen={setModalOpen} />
      )}
    </div>
  );
};

export default Pricing;
